module.exports = __webpack_public_path__ + "static/og-image-8f59db9f7ed296deef270c8cf2fee65d.jpeg";